import Router from 'next/router';

import { FILTERS, FILTER_TO_ROUTE_PRODUCT_CATEGORY } from '../constants/filters';
import { PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP } from '../constants/organizationType';
import { generateQueryFromFilters } from '../helpers/generateQueryFromFilters';
import { ITagOption } from '../interfaces/productTags';
import { IRouterQuery } from '../interfaces/routes';

import { getRouteByOrganizationTypeAndQuery } from './getRouteByOrganizationTypeAndReviewTagAlias';
import { getDefaultFilters } from './ratings';
import { createLinkProps } from './routing';

export const removeDefaultsProperties = (target, defaults) => {
  target = { ...target };

  Object.keys(target).forEach((key) => {
    if (target[key] === defaults[key]) {
      delete target[key];
    }
  });

  return target;
};

const replaceRouteWithNewQuery = (query: IRouterQuery, queryParams) => {
  const organizationType = PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP[query.organizationType];

  delete queryParams.organizationType;
  delete queryParams.reviewTagAlias;

  const params = {
    organizationType: query.organizationType,
    ...(query.reviewTagAlias && { reviewTagAlias: query.reviewTagAlias }),
    productCategory: FILTER_TO_ROUTE_PRODUCT_CATEGORY[queryParams.productCategory],
    queryParams,
  };

  const route = getRouteByOrganizationTypeAndQuery(
    organizationType,
    !!params.reviewTagAlias,
    !!queryParams.productCategory,
  );

  delete queryParams.productCategory;

  const { href, as } = createLinkProps('/list', route, params);

  Router.replace(href, as);
};

export const updateRouteInBrowser = (query: IRouterQuery, newFilters: FILTERS, reviewTagInParams?: ITagOption) => {
  const organizationType = PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP[query.organizationType];

  const filtersToRemoveFromRoute = generateQueryFromFilters(getDefaultFilters({ organizationType, reviewTagInParams }));
  const queryFromNewFilters = generateQueryFromFilters(newFilters);

  const removeFrom = {
    ...query,
    ...queryFromNewFilters,
  };

  const whatToRemove = {
    ...filtersToRemoveFromRoute,
  };

  const queryParamsWithoutDefaultFilters = removeDefaultsProperties(removeFrom, whatToRemove);

  replaceRouteWithNewQuery(query, queryParamsWithoutDefaultFilters);
};
